import produce from "immer";
import { constants } from "./actions";
import { commonConstants } from "../common/actions";

const { REQUEST, SUCCESS, FAILURE } = commonConstants;
const { UPDATE_BLAST_FORM_FIELD, SUBMIT_BLAST_FORM } = constants;

const initState = {
  message: "",
  success: {},
  loading: {},
  sending: false,
  error: {},
};

export default function reducer(state = initState, action) {
  switch (action.type) {
    case UPDATE_BLAST_FORM_FIELD:
      return produce(state, (draft) => {
        draft[action.field] = action.value;
        draft.loading = {};
        draft.sending = false;
        draft.error = {};
        draft.success = {};
      });

    case SUBMIT_BLAST_FORM + REQUEST:
      return {
        ...state,
        loading: { source: SUBMIT_BLAST_FORM },
        sending: true,
        error: {},
        success: {},
      };
    case SUBMIT_BLAST_FORM + SUCCESS:
      return {
        ...state,
        message: "",
        success: {
          source: action.payload.source,
          message: action.payload.message,
        },
        loading: {},
        sending: false,
        error: {},
      };
    case SUBMIT_BLAST_FORM + FAILURE:
      return {
        ...state,
        loading: {},
        sending: false,
        error: {
          source: action.payload.source,
          message: action.payload.message,
        },
        success: {},
      };

    default:
      return state;
  }
}
